
import { computed, defineComponent } from "vue";
import { useStore } from "@/store";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "App",
  data() {
    return {
      settingsModal: false,
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const totalVisibleCount = computed(
      () => store.getters.totalVisibleCampaignCount
    );

    const availableVersions = ["jp", "gl"];
    const versionNum = "2.7.0";
    const totalCategories = computed(() => store.getters.totalCategories);
    const totalSections = computed(() => store.getters.totalSections);

    return {
      route,
      totalVisibleCount,
      versionNum,
      availableVersions,
      totalCategories,
      totalSections,
    };
  },
});
